import { render, staticRenderFns } from "./1_AdminDetails.vue?vue&type=template&id=2a2a861a&scoped=true&"
import script from "./1_AdminDetails.vue?vue&type=script&lang=js&"
export * from "./1_AdminDetails.vue?vue&type=script&lang=js&"
import style0 from "./1_AdminDetails.vue?vue&type=style&index=0&id=2a2a861a&lang=scss&scoped=true&"
import style1 from "./1_AdminDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2a861a",
  null
  
)

export default component.exports